import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { useApi } from "../Api";
import { getFilterValue } from "../../utils/FilterUtils";
import {
    ID_FILTER_DEALERS,
    ID_FILTER_LEGAL_ENTITIES,
    ID_FILTER_PRINTOUT_CLUSTER,
    ID_FILTER_PRINTOUT_CODE_SAP,
    ID_FILTER_PRINTOUT_CODE_SAP_M,
    ID_FILTER_PRINTOUT_CREATIONDATEFROM,
    ID_FILTER_PRINTOUT_CREATIONDATETO, ID_FILTER_PRINTOUT_EMAIL_M, ID_FILTER_PRINTOUT_INVOICE_NUMBER,
    ID_FILTER_PRINTOUT_MSCODE,
    ID_FILTER_PRINTOUT_MSNAME,
    ID_FILTER_PRINTOUT_NAME_M,
    ID_FILTER_PRINTOUT_PROPERTY,
    ID_FILTER_PRINTOUT_PUBLISHEDDATEFROM, ID_FILTER_PRINTOUT_PUBLISHEDDATETO,
    ID_FILTER_PRINTOUT_REPORTNAME, ID_FILTER_PRINTOUT_SAP_INVOICE_NUMBER,
    ID_FILTER_PRINTOUT_SENTDATEFROM,
    ID_FILTER_PRINTOUT_SENTDATETO,
    ID_FILTER_PRINTOUT_STATUS,
    ID_FILTER_PRINTOUT_TOTAL_FROM,
    ID_FILTER_PRINTOUT_TOTAL_TO,
    ID_FILTER_PRINTOUT_TYPE,
    ID_FILTER_REPORT_CREATIONDATEFROM,
    ID_FILTER_REPORT_CREATIONDATETO,
    ID_FILTER_REPORT_NAME,
    ID_FILTER_SEARCH
} from "../../pages/mobilitystore/constants/MobilityStoreFilters";
import dayjs from "dayjs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useMobilityStoreRepository = () => {

    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/mobility-store"

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);


    function getReports(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let reportName = getFilterValue(ID_FILTER_REPORT_NAME, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_REPORT_CREATIONDATEFROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_REPORT_CREATIONDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            name: reportName,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/printout-request/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getPrintouts(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let msName = getFilterValue(ID_FILTER_PRINTOUT_MSNAME, filterDefs);
        let msCode = getFilterValue(ID_FILTER_PRINTOUT_MSCODE, filterDefs);
        let type = getFilterValue(ID_FILTER_PRINTOUT_TYPE, filterDefs);
        let status = getFilterValue(ID_FILTER_PRINTOUT_STATUS, filterDefs);
        let creationDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATEFROM, filterDefs);
        let creationDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATETO, filterDefs);
        let sentDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATEFROM, filterDefs);
        let sentDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATETO, filterDefs);
        let reportName: Date = getFilterValue(ID_FILTER_PRINTOUT_REPORTNAME, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);
        let invoiceNumber = getFilterValue(ID_FILTER_PRINTOUT_INVOICE_NUMBER, filterDefs);
        let sapInvoiceNumber = getFilterValue(ID_FILTER_PRINTOUT_SAP_INVOICE_NUMBER, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            msName: msName,
            msCode: msCode,
            type: type,
            statuses: status,
            printoutRequestName: reportName,
            creationDateFrom: creationDateFrom ? dayjs(creationDateFrom).toISOString() : null,
            creationDateTo: creationDateTo ? dayjs(creationDateTo).toISOString() : null,
            sentFrom: sentDateFrom ? dayjs(sentDateFrom).toISOString() : null,
            sentTo: sentDateTo ? dayjs(sentDateTo).toISOString() : null,
            legalEntities,
            dealers,
            invoiceNumber,
            sapInvoiceNumber
        }

        return GET(`${PATH}/printout/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getPrintoutsByReportId(reportId: string): Promise<HTTPGenericResponse> {
        let params = {
            printoutRequestId: reportId,
            legalEntities: allLegalEntities,  // il reportId garantisce il filtri corretto
            dealers: []
        }

        return GET(`${PATH}/printout/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getSinglePrintoutsByReportId(reportId: string, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let msName = getFilterValue(ID_FILTER_PRINTOUT_MSNAME, filterDefs);
        let msSapId = getFilterValue(ID_FILTER_PRINTOUT_CODE_SAP, filterDefs);
        let msVendorId = getFilterValue(ID_FILTER_PRINTOUT_CODE_SAP_M, filterDefs);
        let msVendorName = getFilterValue(ID_FILTER_PRINTOUT_NAME_M, filterDefs);
        let msVendorEmail = getFilterValue(ID_FILTER_PRINTOUT_EMAIL_M, filterDefs);
        let msType = getFilterValue(ID_FILTER_PRINTOUT_PROPERTY, filterDefs);
        let type = getFilterValue(ID_FILTER_PRINTOUT_TYPE, filterDefs);
        let clusterName = getFilterValue(ID_FILTER_PRINTOUT_CLUSTER, filterDefs);
        let totalAmountFrom: number = getFilterValue(ID_FILTER_PRINTOUT_TOTAL_FROM, filterDefs);
        let totalAmountTo: number = getFilterValue(ID_FILTER_PRINTOUT_TOTAL_TO, filterDefs);
        let sentDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_PUBLISHEDDATEFROM, filterDefs);
        let sentDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_PUBLISHEDDATETO, filterDefs);
        let statuses = getFilterValue(ID_FILTER_PRINTOUT_STATUS, filterDefs);
        let invoiceNumber = getFilterValue(ID_FILTER_PRINTOUT_INVOICE_NUMBER, filterDefs);
        let sapInvoiceNumber = getFilterValue(ID_FILTER_PRINTOUT_SAP_INVOICE_NUMBER, filterDefs);

        let params = {
            printoutRequestId:  reportId,
            search: search,
            msName: msName,
            msSapId: msSapId,
            msVendorId: msVendorId,
            msVendorName: msVendorName,
            msVendorEmail: msVendorEmail,
            msType: msType,
            type: type,
            clusterName: clusterName,
            totalAmountFrom: totalAmountFrom ? totalAmountFrom * 100 : totalAmountFrom,
            totalAmountTo: totalAmountTo ? totalAmountTo * 100 : totalAmountTo,
            sentFrom: sentDateFrom ? dayjs(sentDateFrom).toISOString() : null,
            sentTo: sentDateTo ? dayjs(sentDateTo).toISOString() : null,
            statuses: statuses,
            legalEntities: allLegalEntities, // il reportId garantisce il filtri corretto
            dealers: [],
            invoiceNumber,
            sapInvoiceNumber
        }

        return GET(`${PATH}/printout/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }


    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let msName = getFilterValue(ID_FILTER_PRINTOUT_MSNAME, filterDefs);
        let msCode = getFilterValue(ID_FILTER_PRINTOUT_MSCODE, filterDefs);
        let type = getFilterValue(ID_FILTER_PRINTOUT_TYPE, filterDefs);
        let status = getFilterValue(ID_FILTER_PRINTOUT_STATUS, filterDefs);
        let creationDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATEFROM, filterDefs);
        let creationDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_CREATIONDATETO, filterDefs);
        let sentDateFrom: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATEFROM, filterDefs);
        let sentDateTo: Date = getFilterValue(ID_FILTER_PRINTOUT_SENTDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);
 
        let params = {
            search: search,
            msName: msName,
            msCode: msCode,
            type: type,
            statuses: status,
            creationDateFrom: creationDateFrom ? dayjs(creationDateFrom).toISOString() : null,
            creationDateTo: creationDateTo ? dayjs(creationDateTo).toISOString() : null,
            sentFrom: sentDateFrom ? dayjs(sentDateFrom).toISOString() : null,
            sentTo: sentDateTo ? dayjs(sentDateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/printout/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function getSummaryByReportId(id: string): Promise<HTTPGenericResponse> {
        let params = {
            printoutRequestId: id,
            legalEntities: allLegalEntities
        }

        return GET(`${PATH}/printout/all-status-summary`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function postPrintoutRequest(printoutRequest: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}/printout-request`, printoutRequest, {}, true);
    }

    function switchPrintoutManualBilling(id: string) {
        return PUT(`${PATH}/printout/manual-billing`, JSON.stringify(id), {
            headers: {
                'Content-Type': 'application/json'
            }
        }, true);
    }

    function reprocessPrintout(id: string) {
        return PUT(`${PATH}/printout`, JSON.stringify(id), {
            headers: {
                'Content-Type': 'application/json'
            }
        }, true);
    }

    function reprocessPrintouts(id: string) {
        return PUT(`${PATH}/printout/reprocess-all`, JSON.stringify(id), {
            headers: {
                'Content-Type': 'application/json'
            }
        }, true);
    }

    function updatePrintoutStatus(id: string) {
        return PUT(`${PATH}/printout/sent`, JSON.stringify(id), {
            headers: {
                'Content-Type': 'application/json'
            }
        }, true);
    }

    function publishPrintouts(ids: string[]) {
        return PUT(`${PATH}/printout-publish`, ids, {}, true);
    }

    function deletePrintout(id: string) {
        return DELETE(`${PATH}/printout/${id}`, {}, true);
    }

    function deletePrintouts(id: string) {
        return DELETE(`${PATH}/printout/delete-all/${id}`, {}, true);
    }

    function checkClusterMS(printoutRequest: any): Promise<HTTPGenericResponse> {
        return POST(`/finance/cluster-ms/check`, printoutRequest, {}, true);
    }

    function downloadPDF(id: string, extension : string) {
        return GET(`${PATH}/printout/download/${id}/${extension}`);
    }

    function switchReportManualBilling(id: string, manualBilling: boolean): Promise<HTTPGenericResponse> {
        let params = {
            requestId: id,
            valueToSet: manualBilling
        }
        return PUT(`${PATH}/printout/massive-manual-billing`, params, {}, true);
    }

    return {
        getReports,
        getPrintouts,
        getPrintoutsByReportId,
        getSummary,
        getSummaryByReportId,
        postPrintoutRequest,
        switchPrintoutManualBilling,
        reprocessPrintout,
        reprocessPrintouts,
        updatePrintoutStatus,
        publishPrintouts,
        deletePrintout,
        deletePrintouts,
        checkClusterMS,
        downloadPDF,
        switchReportManualBilling,
        getSinglePrintoutsByReportId
    };
}